// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SFyh","title":"Header_title__3eURG","side":"Header_side__3CwvO"};